import { removeWhen } from './removeWhen'
import { isNilOrEmpty } from './isNilOrEmpty'

export const removeNil = removeWhen(isNilOrEmpty)
